import type { NutzerProfil } from '../types';

let _nutzer: NutzerProfil | null = null;

export function registerAktuellerNutzer(n: NutzerProfil | null) {
  _nutzer = n;
}

export function getAktuellerNutzer(): NutzerProfil | null {
  return _nutzer;
}
